import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { CloseOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { ModalWrapper } from './styled'
import { PrimaryButton, OutlineButton } from '../../../../components/button'
import { SelectButton } from '../select-button'

export const ModalAssignee = ({
  t,
  userList,
  selectedAssignees,
  setSelectedAssignees,
  registeredAssignees,
  setRegisteredAssignees,
  isModalVisible,
  setIsModalVisible
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const assignees = useMemo(
    () => userList.filter(({ name }) => name.toLowerCase().includes(searchTerm.toLowerCase())),
    [userList, searchTerm]
  )

  // selectAllは、表示中のassigneesがすべてselectedAssigneesに含まれているかで判断
  const selectAll = assignees.length > 0
    && assignees.every(({ id }) => selectedAssignees.some((sel) => sel.id === id))

  const handleSelectAll = () => {
    if (selectAll) {
      // 全て選択済みの場合は、表示中のassigneesを選択解除する
      setSelectedAssignees((prev) => prev.filter(
        (sel) => !assignees.some((assignee) => assignee.id === sel.id)
      ))
    } else {
      // 表示中のassigneesを全て追加する
      const newAssignees = assignees.filter(
        ({ id }) => !selectedAssignees.some((sel) => sel.id === id)
      )
      setSelectedAssignees((prev) => [...prev, ...newAssignees])
    }
  }

  const handleSelectAssignee = (id) => {
    setSelectedAssignees((prev) => {
      // 既に選択されている場合は除外する
      if (prev.some((sel) => sel.id === id)) {
        return prev.filter((sel) => sel.id !== id)
      }
      // 選択されていない場合は、userListから該当のオブジェクトを取得して追加する
      const selectedObject = userList.find((item) => item.id === id)
      return [...prev, selectedObject]
    })
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const handleOk = () => {
    setIsModalVisible(false)
    setRegisteredAssignees(selectedAssignees)
    setSearchTerm('')
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    setSelectedAssignees(registeredAssignees)
    setSearchTerm('')
  }

  const Footer = () => (
    <div className="footer">
      <PrimaryButton onClick={handleOk} title={t('task.save')} />
      <OutlineButton onClick={handleCancel} title={t('task.cancel')} />
    </div>
  )

  return (
    <ModalWrapper
      centered
      open={isModalVisible}
      onCancel={handleCancel}
      title={t('task.select_assignee')}
      footer={<Footer />}
    >
      <div className="content-wrapper">
        <div className="filter">
          <div className="search">
            <input onChange={handleSearch} value={searchTerm} placeholder={`${t('task.search')}...`} type="search" />

            <Tooltip title={t('task.clear')}>
              <button type="button" onClick={() => setSearchTerm('')}>
                <CloseOutlined />
              </button>
            </Tooltip>
          </div>

          <label className="select-all" htmlFor="select-all" onClick={handleSelectAll}>
            <SelectButton id="select-all" selected={selectAll} />
            {t('task.select_all')}
          </label>
        </div>

        <div className="assignee-list">
          {assignees.length === 0 && <div style={{ fontSize: 13, color: '#aaa' }}>{t('task.no_search_result')}</div>}
          {assignees.map(({ id, name }) => (
            <label key={id} className="assignee-item" htmlFor={`assignee-${id}`} onClick={() => handleSelectAssignee(id)}>
              <SelectButton id={`assignee-${id}`} selected={selectedAssignees.some((sel) => sel.id === id)} />
              {name}
            </label>
          ))}
        </div>
      </div>
    </ModalWrapper>
  )
}

ModalAssignee.propTypes = {
  t: PropTypes.func,
  userList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired,
  selectedAssignees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  setSelectedAssignees: PropTypes.func,
  registeredAssignees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ),
  setRegisteredAssignees: PropTypes.func,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func
}
